// Updated: 06-04-2026
// Changes:
// - Payment type filter options updated to match new enum:
//   Token, Booking, Final removed → Installment, Commission, Other remain

import React from "react";
import "../../css/payments/paymentfilter.css";

export default function PaymentFilters({ filters, setFilters }) {
  return (
    <div className="payment-filters">
      {/* Status Filter */}
      <select
        className="filter-select"
        value={filters.status}
        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
      >
        <option value="all">All Status</option>
        <option value="Pending">Pending</option>
        <option value="Received">Received</option>
        <option value="Overdue">Overdue</option>
      </select>

      {/* Payment Type Filter */}
      <select
        className="filter-select"
        value={filters.paymentType}
        onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
      >
        <option value="all">All Types</option>
        <option value="Installment">Installment</option>
        <option value="Commission">Commission</option>
        <option value="Other">Other</option>
      </select>
    </div>
  );
}